<template>
	<div class="wrapper">
		<div>
			<div class="login-content">
				<b-row class="justify-content-lg-center login-info">
					<b-col lg="6" class="tips-wrap">
						<div class="tips">
							<p>温馨提示:</p>
							<p>本网站只限缤纷种苗会员采购专用，想了解更多缤纷成品信息请登入</p>
							<p>缤纷盆栽：<a href="http://www.brightenplant.cn" target="_blank">www.brightenplant.cn</a></p>
							<p>缤纷鲜花：<a href="http://www.brightenflower.cn" target="_blank">www.brightenflower.cn</a></p>
							<p>客服电话：15288233853</p>
						</div>
						<div class="download" style="text-align:center;">
							<img src="../../assets/download_qrcode.png" style="width:125px;height:125px;">
							<p>缤纷种苗App下载</p>
						</div>
					</b-col>

					<b-col lg="6" class="login-wrap">
						<b-card v-if="!loginType" class="phone-login">
							<div slot="header" class="login_div_header">
								<a href="#" @click="loginType = !loginType">切换为账号登录</a>
							</div>
							<div class="login-title">会员登录</div>
							<b-form class="flex-center">
								<b-form-group class="input-wrap">
									<b-form-input v-model="form.userPhone" placeholder="请输入注册手机号" 
										@blur="memberPhoneBlur(form.userPhone)" autocomplete="off" class="new-input">
									</b-form-input>
									<img src="../../assets/phone.png" class="input-icon">
								</b-form-group>
								<b-form-group class="input-wrap">
									<b-input-group>
										<b-form-input v-model="form.smsCode" autocomplete="off" placeholder="请输入验证码"
											class="new-input code-input">
										</b-form-input>
										<img src="../../assets/code.png" class="input-icon">
										<b-input-group-append>
											<b-button :disabled="timer !== 60" @click="getSmsCode()" class="btn-code">
												{{smsButtonText}}
											</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
								<div style="float:right;" class="new-btn-wrap">
									<b-button @click="loginByPhone" size="sm" variant="primary" :disabled="showSpin"
										class="phone-btn">
										<b-spinner small v-if="showSpin"></b-spinner>
										<span>手机登录</span>
									</b-button>
								</div>
							</b-form>
						</b-card>
						
						<b-card v-if="loginType">
							<div slot="header" class="login_div_header">

								<a href="#" @click="loginType = !loginType">切换为手机登录</a>
							</div>
							<div class="login-title">会员登录</div>

							<b-form @submit="onSubmit" @reset="onReset" class="flex-center">
								<b-form-group class="input-wrap">

									<b-form-input v-model="form.userName" required placeholder="请输入会员账号"
										class="user new-input">
									</b-form-input>
									<img src="../../assets/user.png" class="input-icon">
								</b-form-group>

								<b-form-group class="input-wrap">
									<b-form-input v-model="form.password" required type="password" placeholder="请输入密码"
										class="user-password new-input"></b-form-input>
									<img src="../../assets/password.png" class="input-icon">
								</b-form-group>
								<div class="new-login-btn">
									<b-button type="submit" size="sm" variant="primary" :disabled="showSpin"
										class="new-btn sumbit-btn">
										<b-spinner small v-if="showSpin"></b-spinner>
										<span>账号登录</span>
									</b-button>
									<b-button type="reset" size="sm" variant="danger" class="new-btn reset-btn">清空
									</b-button>

									<!-- <a href="#"
                                class="login_a">忘记密码</a> -->
								</div>
								<div class="regist">
									还没有账号？
									<b-link :to="{ name: 'MemberRegister' }" class="login_a">
										申请会员
									</b-link>
								</div>
							</b-form>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<div class="home-footer">
				<p>版权所有 © 广州缤纷园艺有限公司 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备05082648号</a></p>
				<p>建议使用IE10.0或以上版本浏览本网站</p>
			</div>
		</div>
		<!-- 存在待支付订单 -->
		<b-modal v-model="noDepositListModal.show" size="sm" title="温馨提示">
			<div>您还有待支付的订单，是否现在去支付？</div>
			<template slot="modal-footer">
				<div class="secondaryWrap">
					<b-button variant="success" @click="getNoDepositlist">是</b-button>
					<b-button variant="secondary" @click="hideBtn">否</b-button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import api from '@/api/api';
	import { saveUserInfo, clearUserInfo } from '@/utils/localStorage';
	export default {
		name: "MemberLogin",
		mounted() {
			if (this.checkMemberLogin()) {
				this.getUserDepositBillInfoList();
			}
			let lastLoginInfo = this.getLastLoginInfo();
			if (lastLoginInfo) {
				Object.assign(this.form, lastLoginInfo);
			}
			
		},
		data() {
			return {
				timer: 60,
				smsTimer: null,
				smsButtonText: "获取验证码",
				showSpin: false,
				loginType: true,
				form: {
					userName: '',
					password: '',
					userPhone: '',
					smsCode: '',
					codeType: 'login'
				},
				noDepositListModal:{
					show:false,
					title: '',
					content: ''
				}
			};
		},
		beforeDestroy() {
			clearInterval(this.smsTimer);
			this.smsTimer = null;
			// console.log('leaver');
		},
		methods: {
			getSmsButtonText() {
				this.smsButtonText = this.timer + '秒后再试';
				this.timer -= 1;
				if (this.timer < 0) {
					clearInterval(this.smsTimer);
					this.smsTimer = null;
					this.smsButtonText = "获取验证码";
					this.timer = 60;
				}
			},
			getSmsCode() {
				if (this.form.userPhone === "") {
					this.$bvModal.msgBoxOk("请先输入手机号码", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/); //手机号码
				if (!memPhone.test(this.form.userPhone)) {
				    this.$bvModal.msgBoxOk("手机号码不符合格式", {
				        title: '提示',
				        buttonSize: 'sm'
				    });
				    return;
				}
				api.externalCustomerGetSmsCode(this.form).then(res => {
					if (res.code === 0) {
						this.$bvModal.msgBoxOk("验证码已发送...", {
							title: '提示',
							buttonSize: 'sm'
						});
						this.form.smsCode = "";
						this.smsTimer = setInterval(() => {
							this.getSmsButtonText();
						}, 1000);
					}
				});
			},
			// 手机格式检验
			memberPhoneBlur(val) {
			    var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/); //手机号码
			    if (!memPhone.test(val)) {
			        this.$bvModal.msgBoxOk("手机号码不符合格式", {
			            title: '提示',
			            buttonSize: 'sm'
			        });
			        return;
			    }
			},
			loginByPhone() {
				this.showSpin = true;
				api.userLoginByPhone(this.form).then(res => {
					this.showSpin = false;
					// console.log(res);
					if (res.code === 0) {
						let userInfo = res.data.userInfo;
						let lastLoginInfo = this.getLastLoginInfo();
						//更换登录用户后，清除种植地和配送站的缓存
						if (lastLoginInfo && lastLoginInfo.userName !== userInfo.userName) {
							this.removeAddressStorage();
						}
						let loginToken = res.data.loginToken;
						this.setLoginCookies(loginToken, userInfo.userUuid, userInfo.userName, userInfo.userType);
						this.setLastLoginInfo(this.form);
						this.setAddressStorage(res.data.defaultAddress);
						window.parent.window.location.reload();
					}
				});
			},
			onSubmit(evt) {
				evt.preventDefault();
				this.showSpin = true;
				api.userLogin(this.form).then(res => {
					this.showSpin = false;
					// console.log(res);
					if (res.code === 0) {
						let userInfo = res.data.userInfo;
						console.log("userInfo", userInfo);
						let lastLoginInfo = this.getLastLoginInfo();
						//更换登录用户后，清除种植地和配送站的缓存
						if (lastLoginInfo && lastLoginInfo.userName !== userInfo.userName) {
							this.removeAddressStorage();
							clearUserInfo();
						}
						let loginToken = res.data.loginToken;
						this.setLoginCookies(loginToken, userInfo.userUuid, userInfo.userName, userInfo.userType);
						this.setLastLoginInfo(this.form);
						this.setAddressStorage(res.data.defaultAddress);
						saveUserInfo(userInfo);
						window.parent.window.location.reload();
					}
				});
			},
			onReset(evt) {
				evt.preventDefault();
				this.form.userName = '';
				this.form.password = '';
			},
			getUserDepositBillInfoList() {
				//获取定金待支付的列表
				api.webGetNoPaidDepositBillOrderList().then(res => {
					if(res.data.depositBillMainVOList.length>0){
						this.noDepositListModal.show=true;
					}else{
						this.hideBtn();
					}
				});
			},
			hideBtn(){
				this.noDepositListModal.show=false;
				this.$router.push({
					name: 'Home'
				});
			},
			getNoDepositlist(){
				this.$router.push({
				    path: "/member/no-deposit-list",
				});
				this.noDepositListModal.show=false;
			}
		},
		components: {

		}
	};
</script>

<style>
	.login_div_header {
		display: flex;
		justify-content: space-between;
	}

	.login_div_header a {
		text-decoration: none;
	}

	.login_a {
		margin-left: 10px;
		font-size: 12px;
	}


	/* new */
	/* body{width:100%;height:100%;background:url(../../assets/bg.png) no-repeat;background-size:cover;} */

	.wrapper {
		background: url(../../assets/bg.png);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		min-width: 1000px;
		z-index: -10;
		zoom: 1;
		background-color: #fff;
		background-repeat: no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	.wrapper .login-content {
		width: 1170px;
		position: absolute !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		-webkit-transform: translate(-50%, -50%) !important;
	}

	.login-info {
		width: 1170px;
		box-shadow: 0px 0px 20px 0px #7d7d7d;
		background-color: #ffffff;
	}

	.tips-wrap {
		background-image: linear-gradient(0deg, #41bf7b, #00b151);
		box-shadow: 2px 2px 3px #6d6d6d;
		z-index: 999;
	}

	.tips {
		padding: 30px 30px;
	}

	.tips p {
		font-size: 22px;
		color: #ffffff;
		margin-bottom: 0.8rem;
	}

	.tips p a {
		color: #ffffff;
	}

	.col,
	.col-1,
	.col-10,
	.col-11,
	.col-12,
	.col-2,
	.col-3,
	.col-4,
	.col-5,
	.col-6,
	.col-7,
	.col-8,
	.col-9,
	.col-auto,
	.col-lg,
	.col-lg-1,
	.col-lg-10,
	.col-lg-11,
	.col-lg-12,
	.col-lg-2,
	.col-lg-3,
	.col-lg-4,
	.col-lg-5,
	.col-lg-6,
	.col-lg-7,
	.col-lg-8,
	.col-lg-9,
	.col-lg-auto,
	.col-md,
	.col-md-1,
	.col-md-10,
	.col-md-11,
	.col-md-12,
	.col-md-2,
	.col-md-3,
	.col-md-4,
	.col-md-5,
	.col-md-6,
	.col-md-7,
	.col-md-8,
	.col-md-9,
	.col-md-auto,
	.col-sm,
	.col-sm-1,
	.col-sm-10,
	.col-sm-11,
	.col-sm-12,
	.col-sm-2,
	.col-sm-3,
	.col-sm-4,
	.col-sm-5,
	.col-sm-6,
	.col-sm-7,
	.col-sm-8,
	.col-sm-9,
	.col-sm-auto,
	.col-xl,
	.col-xl-1,
	.col-xl-10,
	.col-xl-11,
	.col-xl-12,
	.col-xl-2,
	.col-xl-3,
	.col-xl-4,
	.col-xl-5,
	.col-xl-6,
	.col-xl-7,
	.col-xl-8,
	.col-xl-9,
	.col-xl-auto {
		padding-right: 0px;
		padding-left: 0px;
	}

	.download p {
		color: #fff;
		font-size: 22px;
		padding: 20px 0px;
	}

	/* 切换登录 */
	.login-wrap .card-header {
		text-align: right;
		padding: 0px;
		margin-bottom: 0;
		background-color: #ffffff;
		border-bottom: none;
		color: #767676;
	}

	.login-wrap .login_div_header a {
		padding: 30px 0px;
		color: #767676;
		font-size: 16px;
		font-weight: normal;
	}

	.login-wrap .login_div_header a:hover {
		color: #767676;
		text-decoration: none;
	}

	.login_div_header {
		justify-content: end;
		float: right;
		padding: 0px 30px;
	}

	.login_div_header a {
		color: #767676;
		font-size: 16px;
	}

	.login-wrap .card {
		border: none;
	}

	.login-wrap .card-body {
		padding: 0px;
		text-align: center;
		margin: 0 auto;
	}

	.login-title {
		font-weight: bold;
		font-size: 40px;
		padding: 50px 0px;
		color: #333;
	}

	/* 输入框样式 */
	.phone-login .btn-secondary{
		background-color: #01b252 !important;
		border-color: #01b252 !important;
	}
	.phone-login .new-input {
		font-size: 22px;
		width: 400px;
		height: 60px !important;
		line-height: 60px !important;
		border-radius: 6px;
		padding: 0px 20px;
		padding-left: 45px !important;
	}

	.login-wrap .form-control {
		font-size: 22px;
		width: 400px;
		height: 60px;
		line-height: 60px;
		border-radius: 6px;
		padding: 0px 20px;
		padding-left: 45px;
	}

	/* 使用背景图,选择历史记录选项时图标会被覆盖 */
	/* .user{background:url(../../assets/user.png) no-repeat;background-position: 15px 15px;background-size:auto;}
.user-password{background:url(../../assets/password.png) no-repeat;background-position: left center;background-size:auto;} */

	/* 使用图片和定位 */
	.input-wrap {
		position: relative;
	}

	.input-icon {
		position: absolute;
		left: 15px;
		top: 15px;
		z-index:999;
	}

	/* 修改input选择历史记录选项时,出现了自带背景色的样式 */
	.form-control:-webkit-autofill {

		-webkit-box-shadow: 0 0 0px 1000px white inset;

		-webkit-text-fill-color: #333;

	}

	/* 注册按钮 */
	.new-btn {
		border-radius: 6px;
		padding: 0px;
		border: none;
		height: 60px;
		line-height: 60px;
	}

	.sumbit-btn {
		background-color: #01b252 !important;
		width: 190px;
		font-size: 22px;
	}

	.reset-btn {
		margin-left: 20px;
		width: 190px;
		font-size: 22px;
	}

	.regist {
		float: right;
		padding: 20px 0px;
		font-size: 16px;
	}

	.regist a {
		color: #01b252;
		margin-left: 0px;
		font-size: 16px;
	}

	.regist a:hover {
		color: #01b252;
		margin-left: 0px;
		font-size: 16px;
		text-decoration: none;
	}

	.login_a {
		margin-left: 0px;
		font-size: 16px;
	}


	.new-login-btn .btn-group-sm>.new-login-btn .btn,
	.phone-login .new-login-btn .btn-sm {
		padding: 0px;
		font-size: 22px;
		border-radius: 5px;
	}

	/* 按钮 */
	.new-btn-wrap .btn-group-sm>.new-btn-wrap .btn,
	.new-btn-wrap .btn-sm {
		width: 400px;
		font-size: 22px;
		border-radius: 6px;
		padding: 0px;
		border: none;
		height: 60px !important;
		line-height: 60px !important;
	}

	/* 验证码 */
	.phone-login .btn-code {
		width: 140px;
		background-color: #01b252;
		border: none !important;
		font-size: 22px;
		height: 60px !important;
		line-height: 60px !important;
		padding:0px !important;
	}

	.input-wrap .input-group-append .btn,
	.input-wrap .input-group-prepend .btn {
		width: 140px;
		background-color: #01b252;
		border: none;
	}


	.btn-secondary.focus,
	.btn-secondary:focus {
		background-color: #00B151 !important;
	}

	.btn-secondary.hover,
	.btn-secondary:hover {
		background-color: #00B151 !important;
	}

	.code-input {
		width: 240px !important;
	}

	.phone-btn {
		margin: 30px 0px;
		background-color: #01b252;
		width: 400px;
		height: 60px;
		line-height: 60px;
		border: none;
		border-radius: 6px;
		padding: 0px;
		font-size: 22px;
	}

	.phone-btn:hover {
		background-color: #01b252;
	}


	/* 底部 */
	.home-footer {
		width: 1170px;
		position: absolute !important;
		left: 50% !important;
		bottom: 0% !important;
		transform: translate(-50%, 0%) !important;
		-webkit-transform: translate(-50%, 0%) !important;
	}

	.home-footer p {
		font-size: 14px;
		color: #8b8b8b;
		text-align: center;
	}

	.home-footer a {
		color: #8b8b8b;
	}


	.new-btn-wrap .btn-primary {
		width: 400px;
		background-color: #01b252 !important;
		border-color: #01b252 !important;
	}

	.new-btn-wrap .btn-primary.focus,
	.new-btn-wrap .btn-primary:focus,
	.new-btn-wrap .btn-primary:hover {
		background-color: #01b252 !important;
		border-color: #01b252 !important;
	}

	.new-login-btn .btn-primary {
		border-color: #01b252 !important;
	}

	.new-login-btn .btn-primary.focus,
	.new-login-btn .btn-primary:focus,
	.new-login-btn .btn-primary:hover {
		background-color: #01b252 !important;
		border-color: #01b252 !important;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/member/login.vue